<template>
  <div class="pagination-numbers">
    <vue-ads-pagination
      :total-items="totalItems"
      :page="currentPage"
      :loading="loading"
      :items-per-page="itemsPerPage"
    >
      <template slot-scope="props">
        <div class="vue-ads-pr-2 vue-ads-leading-loose" style="display: none">
          {{ props }}
        </div>
      </template>
      <template slot="buttons" slot-scope="props">
        <vue-ads-page-button
          v-for="(button, key) in props.buttons"
          :key="key"
          v-bind="customizeButtonElements(button)"
          @page-change="pageChangeButton(button.page)"
          class="paginate-button"
          v-bind:style="{
            backgroundColor: currentPage + 1 === +button.html ? '#0F437B' : '',
            color: currentPage + 1 === +button.html ? '#ffffff' : '',
          }"
        />
      </template>
    </vue-ads-pagination>
  </div>
</template>

<script>
import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";

import "../../../node_modules/@fortawesome/fontawesome-free/css/all.css";
import "../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css";

export default {
  name: "PaginationTable.vue",
  components: { VueAdsPagination, VueAdsPageButton },
  data() {
    return {
      loading: false,
      currentPage: 0,
    };
  },
  methods: {
    pageChangeButton(page) {
      this.currentPage = page;
      this.$emit("onChangedPage", page);
    },
    customizeButtonElements(button) {
      if (button.html.includes("left")) {
        return {
          ...button,
          html: button.html.replace("left", "right"),
        };
      }

      if (button.html.includes("right")) {
        return {
          ...button,
          html: button.html.replace("right", "left"),
        };
      }

      return button;
    },
  },
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.pagination-numbers {
  margin: auto;

  .paginate-button {
    height: 30px;
    width: 30px;
    cursor: pointer;
    border-radius: 50%;
    background-color: transparent;
    border: none;
    color: #232323;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-size: 1rem;
    margin: 10px 0;

    &:hover {
      background-color: #f5f5f5;
    }
  }

  .vue-ads-m-2 {
    margin: 0;
  }

  .next-button,
  .prev-button {
    background-color: black;
    color: white;
    border-radius: 8px;
    height: 30px;
    width: 30px;

    :hover {
      background-color: rgb(45, 45, 45);
    }

    :active {
      background-color: rgb(85, 85, 85);
    }
  }
}
</style>
